// extracted by mini-css-extract-plugin
export var highlightFade = "_2z-4";
export var highlighted = "_2z-3";
export var table = "_2z-1";
export var tableContainer = "_2z-0";
export var totalsRow = "_2z-2";